import { render } from "./GridOrganigrama.vue?vue&type=template&id=08bc8cc5&ts=true"
import script from "./GridOrganigrama.vue?vue&type=script&lang=ts"
export * from "./GridOrganigrama.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__